import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

export interface AutorivFastener {
  fastenerType: string;
  studNut: string | null;
  fastenerGroup: string | null;
  installationForceTons: string | null;
  installationForceKn: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedAutorivFasteners {
  data: AutorivFastener[];
  pagination: PaginationMeta;
}

export type AutorivSortColumn =
  | "fastenerType"
  | "studNut"
  | "fastenerGroup"
  | "installationForceTons"
  | "installationForceKn";

export interface ListAutorivFastenersParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: AutorivSortColumn;
  sortOrder?: "asc" | "desc";
}

export interface UpdateAutorivFastenerBody {
  studNut?: "Stud" | "Nut" | null;
  fastenerGroup?: string | null;
  installationForceTons?: string | number | null;
  installationForceKn?: string | number | null;
}

export interface CreateAutorivFastenerBody {
  fastenerType: string;
  studNut?: "Stud" | "Nut" | null;
  fastenerGroup?: string | null;
  installationForceTons?: string | number | null;
  installationForceKn?: string | number | null;
}

export async function listAutorivFasteners(
  params: ListAutorivFastenersParams = {},
): Promise<PaginatedAutorivFasteners> {
  const res = await Api.get("/v1/autoriv-fasteners", { params });
  return unwrap<PaginatedAutorivFasteners>(res.data);
}

export async function getAutorivFastener(
  fastenerType: string,
): Promise<AutorivFastener> {
  const res = await Api.get(
    `/v1/autoriv-fasteners/${encodeURIComponent(fastenerType)}`,
  );
  return unwrap<AutorivFastener>(res.data);
}

export async function updateAutorivFastener(
  fastenerType: string,
  body: UpdateAutorivFastenerBody,
): Promise<AutorivFastener> {
  const res = await Api.put(
    `/v1/autoriv-fasteners/${encodeURIComponent(fastenerType)}`,
    body,
  );
  return unwrap<AutorivFastener>(res.data);
}

export async function createAutorivFastener(
  body: CreateAutorivFastenerBody,
): Promise<AutorivFastener> {
  const res = await Api.post("/v1/autoriv-fasteners", body);
  return unwrap<AutorivFastener>(res.data);
}

export async function listAutorivFastenerGroups(): Promise<{ groups: string[] }> {
  const res = await Api.get("/v1/autoriv-fasteners/groups");
  return unwrap<{ groups: string[] }>(res.data);
}

export async function deleteAutorivFastener(
  fastenerType: string,
): Promise<{ success: true }> {
  const res = await Api.delete(
    `/v1/autoriv-fasteners/${encodeURIComponent(fastenerType)}`,
  );
  return unwrap<{ success: true }>(res.data);
}
